import {Application, EndpointApplication} from "../domain/Application.model";

export const createAdapterApplication = (application: EndpointApplication) => {
    const formattedApplication: Application = {
        id: application.id,
        name: application.name
    };
    return formattedApplication;
}
